import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const MedicalServiceIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M11.448 2.16599L3.448 7.46499C3.168 7.65099 3 7.96399 3 8.29899V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V8.29899C21 7.96399 20.832 7.65099 20.552 7.46499L12.552 2.16599C12.217 1.94499 11.783 1.94499 11.448 2.16599ZM15 14H13V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V14H9C8.448 14 8 13.552 8 13C8 12.448 8.448 12 9 12H11V9.99999C11 9.44799 11.448 8.99999 12 8.99999C12.552 8.99999 13 9.44799 13 9.99999V12H15C15.552 12 16 12.448 16 13C16 13.552 15.552 14 15 14Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

MedicalServiceIcon.propTypes = {
  sx: PropTypes.object,
};

export default MedicalServiceIcon;
